import React from 'react';
import { Close, Search, Input } from './style';
import { useTranslation } from 'i18n';
import { withForwardRef } from 'hoc';

export interface SearchInputProps {
  clearSearch: Function;
  name?: string;
  iconLeftClick?: Function;
}

const defaultProps = {};

function SearchInput(props: SearchInputProps) {
  const { t } = useTranslation();
  return (
    <Input
      name="search"
      {...props}
      placeholder={t('Type search term...')}
      iconLeft={<Search onClick={props.iconLeftClick} />}
      iconRight={(value: string) =>
        value && <Close onClick={props.clearSearch} />
      }
    />
  );
}

SearchInput.defaultProps = defaultProps;

export default withForwardRef(SearchInput);
